import { useTranslate } from "@/hooks";
import { INoOptionTextProps } from "./NoOptionText.props";
import styles from "./NoOptionText.module.scss";

const NoOptionText = ({ ...props }: INoOptionTextProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<div className={styles.noOptionText} {...props}>
			{translate("title_notFound")}
		</div>
	);
};

export default NoOptionText;
